export default __webpack_public_path__ + "be72fcae85c205e42b26dabfa7fcd456.svg";